import { Dialog, Transition } from '@headlessui/react';
import { Fragment, useState, useContext } from 'react';
import { useNavigate } from 'react-router-dom';
import { AiOutlineDelete } from 'react-icons/ai';
import { FaBagShopping } from 'react-icons/fa6';
import { MdClose } from 'react-icons/md';

import Whatsapp from '../Whatsapp';
import CartContext from '../../context/CartContext';
import ButtonCircle3 from '../../shared/Button/ButtonCircle3';
import ButtonSecondary from '../../shared/Button/ButtonSecondary';
import InputNumber from '../../shared/InputNumber/InputNumber';

import toast, { Toaster } from 'react-hot-toast';
import { PiSealCheckFill } from 'react-icons/pi';


const CartSideBar = () => {
  const navigate = useNavigate()
  const { removeItem } = useContext(CartContext)
  let { cart } = useContext(CartContext);

  if (!cart) {
    cart = []
  }

  const [isVisable, setIsVisable] = useState(false);

  const handleOpenMenu = () => setIsVisable(true);
  const handleCloseMenu = () => setIsVisable(false);
  const total = cart.reduce((acc, item) => {
    return acc + item.price * item.quantity;
  }, 0);

  const renderProduct = (item) => {
    const { slug, coverImage, price, productCategory, quantity, url, stock } = item;

    const deleteItem = (item) => {
      removeItem(item.slug);
      toast.custom((t) => (
        <div
          className={`${t.visible ? 'animate-enter' : 'animate-leave'
            } max-w-md bg-white shadow-lg rounded-lg border-red pointer-events-auto flex`}
        >
          <div className="flex-1 w-0 p-4">
            <div className="flex items-center">
              <div className="flex-shrink-0">
                <div className="bg-red rounded-full p-1">
                  <PiSealCheckFill className="text-red w-5 h-5" />
                </div>
              </div>
              <div className="ml-3 flex-1">
                <p className="text-sm font-medium text-red">
                  {`${item.slug} fue eliminado del carrito`}
                </p>
              </div>
            </div>
          </div>
        </div>
      ));
    };

    return (
      <div key={slug} className="flex mt-5 mb-5 last:pb-0">
        <div
          className="relative h-24 w-24 shrink-0 overflow-hidden rounded-xl cursor-pointer"
          onClick={() => {
            handleCloseMenu();
            navigate(`${url}`);
          }}
        >
          <img
            src={coverImage}
            alt={slug}
            className="h-full w-full object-contain object-center"
          />
        </div>

        <div className="ml-4 flex flex-1 flex-col justify-between">
          <div>
            <div className="flex justify-between">
              <div>
                <h3
                  className="font-medium text-white cursor-pointer hover:underline"
                  onClick={() => {
                    handleCloseMenu();
                    navigate(`${url}`);
                  }}
                >
                  {slug}
                </h3>
                <span className="my-1 text-sm text-neutral-400">
                  {productCategory}
                </span>
                <div className="flex items-center gap-1 mt-4">
                  <span className="font-medium text-white mr-4 bg-primary p-2 rounded-xl flex justify-center">
                    ${Math.round((price * quantity) * 1.10)}
                  </span>
                  <span className="font-medium text-primary mr-4 bg-white p-2 rounded-xl">
                    ${price * quantity}
                  </span>
                </div>
              </div>
            </div>
          </div>
          <div className="flex w-full items-end justify-between text-sm">
            <div className="flex items-center gap-3">
              <AiOutlineDelete
                onClick={() => deleteItem(item)}
                className="text-2xl cursor-pointer transitionEffect text-white"
              />
            </div>
            <div className="mr-4">
              <InputNumber
                valueClassName="text-white text-xl"
                defaultValue={quantity}
                item={item}
                {...(stock ? { max: stock } : {})}
              />
            </div>
          </div>
        </div>
      </div>
    );
  };

  const renderContent = () => {
    return (
      <Transition appear show={isVisable} as={Fragment}>
        <Dialog
          as="div"
          className="fixed inset-0 z-50 overflow-y-auto"
          onClose={handleCloseMenu}
        >
          <div className="z-max fixed inset-y-0 right-0 w-full max-w-md outline-none focus:outline-none md:max-w-md">
            <Transition.Child
              as={Fragment}
              enter="transition duration-100 transform"
              enterFrom="opacity-0 translate-x-full"
              enterTo="opacity-100 translate-x-0"
              leave="transition duration-150 transform"
              leaveFrom="opacity-100 translate-x-0"
              leaveTo="opacity-0 translate-x-full"
            >
              <div className="relative z-20">
                <div className="overflow-hidden shadow-lg ring-1 ring-black/5">
                  <div className="dark2 relative min-h-screen bg-white pb-[calc(env(safe-area-inset-bottom,0px)+100px)]">
                    <div className="hiddenScrollbar h-screen overflow-y-auto p-5">
                      <div className="flex items-center justify-between">
                        <h3 className="text-xl text-white font-semibold">Mi carrito</h3>
                        <ButtonCircle3 onClick={handleCloseMenu} aria-label='Cerrar carrito de compra' >
                          <MdClose className="text-2xl" />
                        </ButtonCircle3>
                      </div>
                      <div className="overflow-y-auto max-cart">
                        {cart.map((item, index) => (
                          <div key={item.id || item.slug || index}>
                            {renderProduct(item)}
                            <hr className="mb-3 mt-3 border-neutral-300 xl:mb-12" />
                          </div>
                        ))}
                        {cart.length < 1 ? <p className="mt-10 text-white">No hay productos en tu carrito</p> : null}
                        <Toaster position="bottom-right" reverseOrder={false} />
                      </div>
                      <div
                        className="w-full p-5"
                        style={{
                          bottom: 50,
                        }}
                      >
                        {cart.length > 0 && (
                          <>
                            <p className="flex justify-between mb-2 bg-primary text-white p-4 rounded-xl">
                              <span>
                                <span className="font-medium">Subtotal con Mercado Pago</span>
                              </span>
                              <span className="font-medium">${Math.round(total * 1.10)}</span>
                            </p>
                            <p className="flex justify-between mt-2 bg-white text-primary p-4 rounded-xl">
                              <span>
                                <span className="font-medium text-primary">Subtotal Con transferencia</span>
                              </span>
                              <span className="font-medium text-primary">Descuento adicional</span>
                              <span className="text-xl text-primary font-medium">${total}</span>
                            </p>
                          </>
                        )}
                        <div className="mt-5 flex items-center gap-5">
                          <Whatsapp onClick={handleCloseMenu} content={cart} info=""></Whatsapp>
                          <ButtonSecondary
                            onClick={() => {
                              handleCloseMenu();
                              navigate('/cart');
                            }}
                            ariaLabel='Ver carrito de compras'
                            className="w-full mt-4 flex-2 text-primary bg-white"
                          >
                            Ver Carrito
                          </ButtonSecondary>

                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </Transition.Child>
            <Transition.Child
              as={Fragment}
              enter=" duration-300"
              enterFrom="opacity-0"
              enterTo="opacity-100"
              leave=" duration-200"
              leaveFrom="opacity-100"
              leaveTo="opacity-0"
            >
              <Dialog.Overlay className="fixed inset-0 bg-neutral-900/60" />
            </Transition.Child>
          </div>
        </Dialog>
      </Transition>
    );
  };

  return (
    <>
      <button
        type="button"
        onClick={handleOpenMenu}
        aria-label="Abrir carrito de compras"
        className="mx-5 flex items-center gap-1 rounded-full bg-neutral-100 p-2 text-primary focus:outline-none focus-visible:ring-2 focus-visible:ring-white focus-visible:ring-opacity-75"
      >
        <FaBagShopping className="text-2xl" />
        <span className="hidden text-sm text-black lg:block">{cart.length} items</span>
      </button>
      {renderContent()}
    </>
  );
};

export default CartSideBar;
